export const en = {
  languageCode: 'en',
  nativeName: 'English',
  hello: 'Hello',
  welcome: 'Welcome',
  enterName: 'Name',
  Beginner: 'Beginner',
  Intermediate: 'Intermediate',
  Advanced: 'Advanced',
  rooms: 'Rooms',
  findPerfectRoom: 'Find the perfect room to practice your language skills',
  createRoom: 'Create Room',
  filterRooms: 'Filter Rooms',
  activeFilters: 'Active filters',
  searchIn: 'Search in',
  whyItWorks: 'Why it works',
  howItWorks: 'How it works',
  targetGroup: 'Target Group',
  earlyAccess: 'Early Access',
  speakLearnConnect: 'Speak. Learn. Connect.',
  whyLanguageRoomsWorks: 'Why Language Rooms works',
  theLanguageRoomsMethod: 'The Language Rooms Method',
  howLanguageRoomsWorks: 'How Language Rooms works',
  becomeALanguageRoomsPioneer: 'Become a Language Rooms pioneer',
  yourVoiceMatters: 'Your Voice Matters',
  perfectForIntermediateLearnersAndBeyond:
    'Perfect for Intermediate Learners and Beyond',
  whoBenefitsMost: 'Who benefits most',
  ourExcitingRoadmap: 'Our exciting roadmap',
  whyYourFeedBackIsCrucial: 'What can we improve?',
  howToProvideFeedback: 'How to provide feedback',
  speakEarlySpeakOften: 'Speak early, Speak often',
  learnFromNativeSpeakers: 'Learn from native speakers',
  embraceTheFun: 'Embrace the fun',
  progressingLearners: 'Progressing Learners',
  rustySpeakers: 'Rusty Speakers',
  skillMaintainers: 'Skill Maintainers',
  culturalEnthusiasts: 'Cultural Enthusiasts',
  joinARoom: 'Join a room',
  startSpeaking: 'Start speaking',
  levelUpYourLingo: 'Level up your lingo',
  phaseOneLaunch: 'Phase 1: Launch',
  phaseTwoCommunityGrowth: 'Phase 2: Community Growth',
  phaseThreeGlobalScale: 'Phase 3: Global Scale',
  traditionalMethod: 'Traditional Method',
  languageRoomsMethod: 'Language Rooms Method',
  join: 'Join',
  create: 'Create',
  save: 'Save',
  cancel: 'Cancel',
  leave: 'Leave',
  checkAudioDevices: 'Check audio devices',
  mute: 'Mute',
  unmute: 'Unmute',
  back: 'Back',
  joinTheWaitlist: 'Join the waitlist',
  exploreRooms: 'Explore rooms',
  requestEarlyAccess: 'Request early access',
  earlyAccessRequested: 'Early access requested',
  searchRooms: 'Search by title or description...',
  allLanguages: 'All Languages',
  allLevels: 'All Levels',
  search: 'Search',
  title: 'Title',
  description: 'Description',
  difficulty: 'Difficulty',
  tags: 'Tags',
  maxTags: 'max {0}',
  charactersMax: '{0} characters max',
  maximal: 'maximum',
  titlePlaceholder: 'Enter a descriptive title for your room',
  descriptionPlaceholder: 'Describe what participants can expect in your room',
  allRightsReservedFunny:
    "All rights reserved. Now go practice your rolled R's!",
  connectWithNativeSpeakersEngage: `Connect with native speakers, engage in real conversations and learn through speaking. Join our vibrant community today.`,
  ourPlatformFocusesOnSpeaking:
    'Our platform focuses on speaking first, making language learning fun and effective.',
  weHaveThreeCorePrinciples:
    'We have three core principles as the foundation of Language Rooms. They are tested and proven to provide rapid and effective learning.',
  languageRoomsIsDesignedTo:
    "Language Rooms is designed to take your skills to the next level. Whether you're looking to improve, maintain, or regain your language abilities, our platform provides the perfect environment for your journey.",
  wereGraduatelyOpeningOurDoors:
    'Welcome to Language Rooms! Join our founding members and start having real conversations now.',
  weValueYourInput: 'We value your input',
  lookForTheFeedbackButton:
    'Look for the "Give Feedback" button at the bottom right of every page. Your insights help us create the best possible language learning experience.',
  sevenYears: '7 Years',
  threeMonths: '3 Months',
  yearsOfTextBooksAndGrammar:
    'Years of textbooks and grammar drills led to perfect conjugations but panic in real conversations.',
  immersiveLearningAndRealConversations:
    'Immersive learning and real conversations led to confident Spanish skills in just three months.',
  noMoreYearsOfSilentStudy:
    'No more years of silent study. Start speaking immediately, even if it\'s just "Hola" on repeat. It\'s how I jumpstarted my Spanish journey.',
  textBooksCantTeachYou:
    "Textbooks can't teach you how locals really talk. Our platform connects you with native speakers for authentic, practical language use.",
  learningALanguageShouldBeFun:
    "Learning a language should be enjoyable, not a chore. We've infused fun into every aspect of Language Rooms, because we know firsthand that it works.",
  extensiveGrammarFocus: 'Extensive grammar focus',
  vocabularyMemorization: 'Vocabulary memorization',
  limitedPracticalApplication: 'Limited practical application',
  focusOnPracticalUsage: 'Focus on practical usage',
  dailyConversationPractice: 'Daily conversation practice',
  highConfidenceInRealSituations: 'High confidence in real situations',
  shapeTheFutureOfLanguageRooms: 'Shape the future of Language Rooms',
  suggestNewFeaturesAndImprovements: 'Suggest new features or improvements',
  reportAnyIssues: 'Report any issues you encounter',
  shareYourSuccessStories: 'Share your success stories',
  error: 'Error',
  startAConversation: 'Start a conversation',
  chatWithOtherParticipants:
    'Chat with other participants in this room. Share ideas, ask questions, or just say hello!',
  anonymous: 'Anonymous',
  localStreamNotFound:
    'Microphone access is required for voice chat. Please click the microphone icon in your browser and allow access to continue speaking with others.',
  typeMessage: 'Type a message...',
  showChat: 'Show chat',
  hideChat: 'Hide chat',
  DailyLife: 'Daily Life',
  FoodAndDrink: 'Food & Drink',
  Travel: 'Travel',
  Culture: 'Culture',
  Business: 'Business',
  Technology: 'Technology',
  Entertainment: 'Entertainment',
  Sports: 'Sports',
  Education: 'Education',
  Arts: 'Arts',
  Music: 'Music',
  Literature: 'Literature',
  CurrentEvents: 'Current Events',
  Science: 'Science',
  HealthAndWellness: 'Health & Wellness',
  Hobbies: 'Hobbies',
  language: 'Language',
  English: 'English',
  Spanish: 'Spanish',
  German: 'German',
  French: 'French',
  Italian: 'Italian',
  Japanese: 'Japanese',
  Chinese: 'Chinese',
  Korean: 'Korean',
  noRoomsFound: 'No rooms found',
  itLooksLikeThereAreNoRooms: `It looks like there aren't any rooms available right now. You can try adjusting your filters or create a new room to start a conversation!`,
  participant: 'participant',
  participants: 'Participants',
  enableVoiceChat: 'Enable Voice Chat',
  tryAgain: 'Try Again',
  loading: 'Loading...',
  edit: 'Edit',
  stayAnonymous: 'Stay Anonymous',
  joinAnonymously: 'Join Anonymously',
  featuredRooms: 'Featured Rooms',
  joinOneOfOurPopularRooms:
    'Join one of our popular rooms and start practicing with native speakers right away.',
  readyToStartSpeaking: 'Ready to Start Speaking?',
  joinARoomAndStartPracticing:
    'Join a room now and start practicing with native speakers. The best way to learn is by doing!',
  findARoomNow: 'Find a Room Now',
  pioneerBadge: 'Pioneer Badge',
  betaTester: 'Beta Tester',
  welcomeMessage: 'Welcome to Language Rooms!',
  foundingMember: 'Founding Member',
  founderBadgeTitle: 'Founding Member',
  welcomeToLanguageRooms: 'Welcome to Language Rooms!',
  welcomeSubtitle: 'The fastest way to speak languages with confidence',
  welcomeDescription:
    "You're one of our first visitors! Join us in creating the most effective platform for language speaking practice.",
  joinPioneerCommunity: 'Join Our Pioneer Community',
  pioneerCommunityDescription:
    'Be among the first to practice languages through real conversations',
  earlyAccessBenefits: 'Early Access Benefits',
  earlyAccessBenefitsDescription:
    'Get exclusive features and priority support as a founding member',
  helpUsGrow: 'Help Shape the Future',
  helpUsGrowDescription:
    'Your feedback will help create the best speaking practice platform',
  whySpeakingMatters: 'Why Speaking Matters',
  whySpeakingMattersDescription:
    'Speaking is the fastest way to master a language. No more silent studying - start talking now!',
  getStartedButton: 'Start Speaking Now',
  thankYouForYourFeedback: 'Thank you for your feedback!',
  giveFeedback: 'Give feedback',
  sendFeedback: 'Send feedback',
  shareFeedbackSubtitle:
    'Share your thoughts, ideas, issues or simply say hi 👋🏻',
  somethingWentWrong: 'Something went wrong',
  unexpectedError: 'An unexpected error occurred',
  errorPageMessage:
    'We apologize for the inconvenience. Please try again or return to the previous page.',
  useFeedbackTool: 'Having issues? Please feel free to give us feedback.',
  pageNotFound: 'Page Not Found',
  pageNotFoundMessage:
    'The page you are looking for does not exist or has been moved.',
  backToHome: 'Back to Home',
  justNow: 'just now',
  minuteAgo: '1 minute ago',
  minutesAgo: '{0} minutes ago',
  hourAgo: '1 hour ago',
  hoursAgo: '{0} hours ago',
  dayAgo: '1 day ago',
  daysAgo: '{0} days ago',
  weekAgo: '1 week ago',
  weeksAgo: '{0} weeks ago',
  monthAgo: '1 month ago',
  monthsAgo: '{0} months ago',
  yearAgo: '1 year ago',
  yearsAgo: '{0} years ago',
  letsSpeak: `Let's speak!`,
  letsSpeakMessage: `Remember, making mistakes is part of learning. The more you speak, the more confident you'll become!`,
  roomInfo: 'Room Info',
  share: 'Share',
  shareRoom: 'Share Room',
  suggestedQuestions: 'Suggested Questions',
  conversationStarters: 'Conversation Starters',
  vocabulary: 'Vocabulary',
  relatedToTags: 'Tag related',
  other: 'Other',
  general: 'General',
  questions: 'questions',
  more: 'More',
  needSomethingElse: 'Need something else?',
  speakingMaterialFeedbackPrompt:
    'If you need something else to help you while speaking, please let us know and we will consider adding it to the speaking material.',
  additionalFeedback:
    'Also if you have any additional feedback on the material, we would like to hear from you.',
  enterYourName: 'What is your name?',
  learnLanguages: 'Learn Languages',
  through: 'Through',
  speaking: 'Speaking',
  whichLanguageDoYouWantToSpeak: 'Which language do you want to speak?',
  joinSpeakersFromOver: 'Join speakers from over 20+ countries worldwide',
  exploreMoreLanguages: 'Explore More Languages',
  online: 'online',
  languagesAvailable: 'Languages Available',
  practiceAnytime: 'Practice Anytime',
  why: 'Why',
  worksBetter: 'Works Better',
  traditionalLearning: 'Traditional Learning',
  yearsOfFrenchInSchool: 'Years of French in School',
  countlessHoursMemorizingVerbConjugations:
    'Countless hours memorizing verb conjugations',
  perfectTestScoresButNeverSpokeInClass:
    'Perfect test scores but never spoke in class',
  resultCantHoldBasicConversationToday:
    "Result: Can't hold a basic conversation today",
  monthsOfSpanishPractice: 'Months of Spanish Practice',
  dailyConversationsWithNativeSpeakers:
    'Daily conversations with native speakers',
  learningThroughRealWorldDiscussions:
    'Learning through real-world discussions',
  resultConfidentlySpeakingWithNatives:
    'Result: Confidently speaking with natives',
  immediatePractice: 'Immediate Practice',
  nativeSpeakers: 'Native Speakers',
  realResults: 'Real Results',
  startSpeakingFromDayOneNoMoreSilentStudying:
    'Start speaking from day one, no more silent studying',
  learnHowLocalsReallyTalkNotJustTextbookPhrases:
    'Learn how locals really talk, not just textbook phrases',
  buildGenuineConfidenceThroughActualConversations:
    'Build genuine confidence through actual conversations',
  realStoriesRealProgress: 'Real Stories, Real Progress',
  joinThousandsOfLanguageLearners:
    'Join thousands of language learners who found their speaking confidence through Language Rooms',
  afterReturningFromSpainIStruggled:
    'After returning from Spain, I struggled to maintain my Spanish. Language Rooms gives me daily opportunities to speak with natives, keeping my skills sharp.',
  iCompletedAllOfDuolingo:
    "I completed many language lessons but couldn't speak confidently. Here, I practice real conversations and my speaking anxiety has disappeared!",
  asABusyProfessionalINeededFlexiblePracticeTimes:
    'As a busy professional, I needed flexible practice times. The 24/7 availability of native speakers here is exactly what I was looking for.',
  returnedExchangeStudent: 'Returned Exchange Student',
  languageEnthusiast: 'Language Enthusiast',
  businessProfessional: 'Business Professional',
  joinLearnersFromOver: 'Join learners from over',
  whoAreAlreadyImprovingTheirLanguageSkills:
    'who are already improving their language skills through real conversations',
  countries: 'countries',
  findThePerfectRoomForYou: 'Find the perfect room for you',
  email: 'Email',
  muted: 'Muted',
  unmuted: 'Unmuted',
  availableSlots: 'Available Slot',
  typeAMessage: 'Type a message...',
  you: 'You',
  noMessagesYetStartTheConversation: 'No messages yet. Start the conversation!',
  microphoneAccessRequired: 'Microphone Access Required',
  microphoneAccessRequiredDescription:
    'To use this platform, you need to allow microphone access. Please enable it in your browser settings and refresh the page.',
  faster: 'Faster',
  thanTraditionalLearning: 'than Traditional Learning',
  realWorldSkills: 'Real-World Skills',
  naturalLanguagePatternsAndExpressions:
    'Natural language patterns and expressions',
  buildConfidenceThroughRegularPractice:
    'Build confidence through regular practice',
  strongFoundation: 'Strong Foundation',
  structuredGrammarAndVocabularyLearning:
    'Structured grammar and vocabulary learning',
  systematicProgressionThroughLanguageLevels:
    'Systematic progression through language levels',
  professionalGuidanceAndFeedback: 'Professional guidance and feedback',
  realWorldSkillsDescription: 'Real-world conversations with native speakers',
  improve: 'Improve',
  yourLanguageSkills: 'Your Language Skills',
  combineStructuredLearningWithRealWorldSpeakingPractice:
    'Combine structured learning with real-world speaking practice',
  serverIssues: 'Server Connection Issues',
  serverIssuesDescription:
    'We are currently experiencing some technical difficulties with our voice chat servers. Voice chat functionality might be temporarily limited. Our team is working on resolving this issue. We apologize for any inconvenience.',
  connecting: 'Connecting',
  roomIsFull: 'This room is full',
  joinAnotherRoom: 'Join another room',
  audioSettings: 'Audio Settings',
  microphone: 'Microphone',
  speaker: 'Speaker',
  audioDevices: 'Audio Devices',
  audioDevicesDescription:
    'Select the audio devices you want to use for voice chat.',
  browseOtherRooms: 'Browse other rooms',
  roomIsFullDescription:
    'This room is currently at maximum capacity. You can wait for someone to leave or try another room.',
  readyToJoin: 'Ready to join{0}?',
  didntFindARoomThatFitsYou: 'Didn’t find a room that fits you?',
  createYourOwnRoomAndStartAConversation:
    'Create your own room and start a conversation on your terms.',
  createARoom: 'Create a Room',
  metaDefaultTitle: 'Speak. Learn. Connect. Language Rooms.',
  metaDefaultDescription:
    'Connect with native speakers, engage in real conversations and learn through speaking. Language Rooms focuses on speaking first, making language learning fun and effective. Join us and speak your way to fluency!',
  metaDefaultKeywords:
    'language, speak, learn, connect, practice, speak language, learn language, Language Rooms, fluency, voice chat, voice, english, spanish, german',
  metaDefaultCanonical: 'https://language-rooms.com',
} as const;
